export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">关于我们</h2>
            <p className="text-sm text-foreground-500">了解51暗网的使命与坚持</p>
          </div>
          <div className="max-w-3xl mx-auto">
            <div className="bg-background-100 rounded-lg border border-background-300/40 p-8">
              <div className="text-center mb-8">
                <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary-500/10 flex items-center justify-center">
                  <i className="ri-eye-line text-2xl text-primary-400"></i>
                </div>
                <h3 className="font-heading text-xl text-foreground-950">51暗网 · 吃瓜爆料聚合平台</h3>
              </div>
              <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
                <p>
                  51暗网诞生于互联网信息爆炸的时代背景下，我们注意到网民在面对海量信息时，
                  往往难以快速找到真实、及时、完整的吃瓜与爆料内容。分散的信息源、频繁失效的访问入口，
                  以及真假难辨的内容质量，让吃瓜变成了一件费心费力的事情。
                </p>
                <p>
                  因此，我们打造了51暗网——一个专注于吃瓜、黑料、爆料内容的聚合入口平台。
                  我们不生产内容，而是通过人工审核与交叉验证，从全网筛选并汇总最值得关注的热门信息，
                  同时维护稳定的访问通道，让用户能够一键触达最全面的吃瓜资讯。
                </p>
                <p>
                  截至目前，51暗网已累计收录超过 200 条爆料线索，覆盖 30 余个垂直话题领域，
                  日均服务数万名吃瓜用户。我们始终坚持内容品质与入口稳定的双重标准，
                  致力于成为中文互联网上最值得信赖的吃瓜入口。
                </p>
              </div>
              <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4 text-center">
                <div className="bg-background-50 rounded-lg p-4">
                  <p className="text-2xl font-heading text-primary-400">200+</p>
                  <p className="text-xs text-foreground-400 mt-1">收录线索</p>
                </div>
                <div className="bg-background-50 rounded-lg p-4">
                  <p className="text-2xl font-heading text-accent-400">30+</p>
                  <p className="text-xs text-foreground-400 mt-1">话题领域</p>
                </div>
                <div className="bg-background-50 rounded-lg p-4">
                  <p className="text-2xl font-heading text-primary-400">99.8%</p>
                  <p className="text-xs text-foreground-400 mt-1">入口可用率</p>
                </div>
                <div className="bg-background-50 rounded-lg p-4">
                  <p className="text-2xl font-heading text-accent-400">37条/天</p>
                  <p className="text-xs text-foreground-400 mt-1">更新频次</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}